export const UPWIND_REGIONS = {
  US: 'US',
  EU: 'EU',
  ME: 'ME',
} as const;

export type UpwindRegion = (typeof UPWIND_REGIONS)[keyof typeof UPWIND_REGIONS];

export const UPWIND_AUTH_URL = 'https://auth.upwind.io/oauth/token';

export const resolveUpwindRegionalAuthUrl = ({
  region,
}: {
  region: UpwindRegion;
}): string => {
  switch (region) {
    case UPWIND_REGIONS.EU:
      return 'https://auth.eu.upwind.io/oauth/token';
    case UPWIND_REGIONS.ME:
      return 'https://auth.me.upwind.io/oauth/token';
    case UPWIND_REGIONS.US:
    default:
      return UPWIND_AUTH_URL;
  }
};

export const resolveUpwindRegionalBaseUrl = ({
  region,
}: {
  region: UpwindRegion;
}): string => {
  switch (region) {
    case UPWIND_REGIONS.EU:
      return 'https://api.eu.upwind.io';
    case UPWIND_REGIONS.ME:
      return 'https://api.me.upwind.io';
    case UPWIND_REGIONS.US:
    default:
      return 'https://api.upwind.io';
  }
};
